var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plugin-item" },
    [
      _c("CompassIcon", { attrs: { icon: _vm.plugin.icon } }),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _c("span", { staticClass: "typographies-paragraph-medium-bold" }, [
            _vm._v(_vm._s(_vm.plugin.title) + " ")
          ]),
          _vm._v(" "),
          _vm.plugin.plan
            ? _c(
                "span",
                { staticClass: "typographies-paragraph-small-semibold" },
                [_vm._v("— " + _vm._s(_vm.plugin.subtitle[_vm.plugin.plan]))]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "description typographies-paragraph-small-regular" },
          [
            _vm._v(
              "\n            " + _vm._s(_vm.plugin.description) + "\n        "
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }